var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Espace administration")]),_c('router-view',{key:_vm.$route.fullPath,attrs:{"name":"vue-interieure-admin"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }